import { render, staticRenderFns } from "./constructed_route.vue?vue&type=template&id=4dcdf437&"
import script from "./constructed_route.vue?vue&type=script&lang=js&"
export * from "./constructed_route.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports